// To parse this data:
//
//   import { Convert, IntroConfig } from "./file";
//
//   const introConfig = Convert.toIntroConfig(json);

export type IntroConfig = {
    logo: string;
    stepTexts: string[];
    sets: Preset[];
};

export type Preset = {
    name: string;
    serie: string;
    config: string;
    stepText?: string;
    sets?: Preset[];
    default?: boolean;
};

// Converts JSON strings to/from your types
export class Convert {
    public static toIntroConfig(json: string): IntroConfig {
        return JSON.parse(json);
    }

    public static introConfigToJson(value: IntroConfig): string {
        return JSON.stringify(value);
    }
}
